import styled from 'styled-components';

import { Color, theme } from '@styles/theme';

export const STATUS_LINE_VARIANTS = ['blue', 'green', 'red', 'orange'] as const;

type StatusLineVariant = (typeof STATUS_LINE_VARIANTS)[number];

export type StatusLineProps = {
  variant: StatusLineVariant;
};

/**
 * `element` tokens rather than the raw ramp, so the line shifts a step in dark mode
 * instead of staying a fixed colour against a changed background. Green stays at 100
 * like its siblings — the header's `elementGreen200` is for text, not a solid block.
 */
export const STATUS_LINE_COLORS: Record<StatusLineVariant, Color> = {
  blue: 'elementBlue100',
  green: 'elementGreen100',
  red: 'elementRed100',
  orange: 'elementOrange100',
};

export function getStatusLineColor(variant: StatusLineVariant) {
  return theme.color[STATUS_LINE_COLORS[variant]];
}

export function StatusLine(props: StatusLineProps) {
  const { variant } = props;

  return <StyledStatusLine className="status-line" $variant={variant} />;
}

const StyledStatusLine = styled.div<{ $variant: StatusLineVariant }>((p) => ({
  height: '100%',
  width: '0.25rem',
  borderRadius: '0.25rem',
  backgroundColor: getStatusLineColor(p.$variant),
  flexShrink: 0,
}));
